import React from 'react';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

/**
 * Barre d'onglets stylée (look « secondary » orange, onglet sélectionné en surbrillance),
 * mutualisée à partir du style utilisé dans InfosPiece. À réutiliser pour tout groupe d'onglets.
 *
 * Usage :
 *   <StyledTabs value={value} onChange={handleChange}>
 *       <StyledTab label="Onglet 1" value="a" />
 *       <StyledTab label="Onglet 2" value="b" />
 *   </StyledTabs>
 */

const tabSx = {
    '&.Mui-selected': {
        color: theme => theme.palette.selected,
    }
};

export const StyledTabs = (props) => (
    <Tabs
        indicatorColor="secondary"
        textColor="secondary"
        {...props}
    />
);

export const StyledTab = ({ sx, ...props }) => (
    <Tab sx={{ ...tabSx, ...sx }} {...props} />
);

export default StyledTabs;
